module.exports = __webpack_public_path__ + "img/email.112ff0fd.jpg";